import { usersApi } from '@/modules/users/users-api';
import type { AuthUser } from '@/modules/auth/auth-service';
import { apiClient } from '@/http/api-client';

export interface UpdateProfileRequest {
  name: string;
}

export interface ChangePasswordRequest {
  currentPassword: string;
  newPassword: string;
  confirmPassword: string;
}

export const settingsApi = {
  changePassword: async (data: ChangePasswordRequest): Promise<void> => {
    await apiClient.post('/v1/im/admin/me/password', {
      current_password: data.currentPassword,
      password: data.newPassword,
      confirm_password: data.confirmPassword,
    });
  },
  updateProfile: async (user: AuthUser, data: UpdateProfileRequest) => {
    return usersApi.updateAdmin({
      id: user.id,
      name: data.name,
      email: user.email,
    });
  },
};
